import React, { useEffect, useState } from 'react';
import useAnnouncements, { Announcement } from '../hooks/useAnnouncements';
import Loading from '@/src/Common/components/Loading';
import moment from 'moment-timezone';
import { Heading } from '@/src/tailwindui/heading';

export default function AnnouncementsView() {
    const [announcements, setAnnouncements] = useState<Announcement[]>([]);
    const { listAnnouncements, isLoading, error } = useAnnouncements();

    useEffect(() => {
        const fetchAnnouncements = async () => {
            const data = await listAnnouncements();
            setAnnouncements(data);
        };

        fetchAnnouncements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (error) {
        return (
            <div className="rounded-md bg-red-50 p-4 mt-4">
                <div className="text-sm text-red-700">{error}</div>
            </div>
        );
    }

    if (isLoading) {
        return <Loading isLoading={true} />;
    }

    return (
        <div className="mx-auto max-w-4xl">
            <div>
                <Heading className="text-3xl md:text-4xl plex-sans">
                    Announcements
                </Heading>
                <p className="text-muted-foreground plex-sans text-[#000] dark:text-[#fff]">
                    Latest updates and releases
                </p>
            </div>
            <div className="mt-8">
                {announcements.map((announcement) => (
                    <div
                        key={announcement.id}
                        className="w-full md:min-w-2/6 md:w-2/6 rounded-none shadow-none border-0 mt-4"
                    >
                        <div className="flex flex-row justify-between ">
                            <div className="text-xl text-[#000] dark:text-[#fff] lowercase monospace-font">
                                <p className="text-muted-foreground text-sm">
                                    {moment(announcement.createdAt).format(
                                        'MM.DD.YYYY',
                                    )}
                                </p>
                                {announcement.title}
                            </div>
                            <div className="flex-1" />
                            <div className="mt-2 text-[#000] dark:text-[#fff] flex flex-row gap-2 monospace-font text-sm">
                                <p className="text-muted-foreground">
                                    authored by <i>{announcement.by}</i>
                                </p>
                            </div>
                        </div>
                        <div
                            className="whitespace-pre-wrap text-[#000] dark:text-[#fff] monospace-font mt-8"
                            dangerouslySetInnerHTML={{
                                __html: announcement.message,
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
